import { Grid, Paper } from "@material-ui/core";
import React from "react";
const AceiteInserido = (props) => {
	console.log(props);
	return (
		<React.Fragment>
			<Paper className="mt-1">
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<h2 className="text-center">Pedido salvo com sucesso!</h2>
						<p className="text-center">
							O pedido agora esta aguardando a confirmação do financeiro da
							Metalife antes de ser inserido no Totvs
						</p>
						<div className="text-center m-2">
							{props.astecChamadoId && props.astecChamadoId !== "" && (
								<a
									className="btn btn-success"
									href={
										"https://astec.metalifepilates.com.br/chamados/" +
										props.astecChamadoId +
										"/edit"
									}
								>
									Voltar para o chamado
								</a>
							)}
							{(!props.astecChamadoId || props.astecChamadoId === "") && (
								<a
									className="btn btn-success"
									href={
										"https://metalife2.pipedrive.com/deal/" +
										props.data.orcamento.negocio_id
									}
								>
									Voltar para o Pipedrive
								</a>
							)}
						</div>
					</Grid>
				</Grid>
			</Paper>
		</React.Fragment>
	);
};

export default AceiteInserido;
